// src/components/charts/CostChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CostChart = ({ data }) => {
  return (
    <div className="chart-container">
      <h3>💰 Costos de IA por día</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis 
            dataKey="fecha" 
            stroke="var(--color-texto)"
            tickFormatter={(fecha) => new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })}
          />
          <YAxis stroke="var(--color-texto)" />
          <Tooltip 
            contentStyle={{ 
              background: 'var(--color-fondo)', 
              border: '1px solid var(--color-primario)',
              borderRadius: '10px'
            }}
            formatter={(value) => `$${parseFloat(value).toFixed(2)}`}
          />
          <Legend />
          <Bar dataKey="costo_imagenes" stackId="a" fill="var(--color-secundario)" name="Imágenes" />
          <Bar dataKey="costo_texto" stackId="a" fill="var(--color-acento)" name="Texto" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CostChart;